import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Text,
  HStack,
} from '@chakra-ui/react'
import { Warning } from '@phosphor-icons/react'

interface ConfirmModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  title?: string
  message: string
  confirmLabel?: string
  cancelLabel?: string
  colorScheme?: string
  isLoading?: boolean
}

export default function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirmar ação',
  message,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  colorScheme = 'red',
  isLoading = false,
}: ConfirmModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="sm">
      <ModalOverlay bg="blackAlpha.700" />
      <ModalContent bg="gray.800" borderColor="gray.700" borderWidth="1px">
        <ModalHeader pb={2}>
          <HStack spacing={2}>
            <Warning size={20} color="#FC8181" weight="fill" />
            <Text fontSize="md" color="white">{title}</Text>
          </HStack>
        </ModalHeader>
        <ModalCloseButton color="gray.400" />
        <ModalBody>
          <Text fontSize="sm" color="gray.300">{message}</Text>
        </ModalBody>
        <ModalFooter gap={3} pt={2}>
          <Button size="sm" variant="ghost" onClick={onClose} isDisabled={isLoading}>
            {cancelLabel}
          </Button>
          <Button
            size="sm"
            colorScheme={colorScheme}
            onClick={() => { onConfirm(); onClose() }}
            isLoading={isLoading}
          >
            {confirmLabel}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
